/** Only paths inside the app, never `//host` or absolute URLs (open redirect). */
export function safePath(value: unknown): string | undefined {
  return typeof value === 'string' &&
    value.startsWith('/') &&
    !value.startsWith('//') &&
    !value.includes('\\')
    ? value
    : undefined;
}
